import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { AnchorWithLink } from 'atoms/Anchor';
import { COMMUNICATION_PREFERENCES_CONSTANTS } from 'organisms/AccountPage/AU/Constants/Constants';
import PropTypes from 'prop-types';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import {
  marketingPreferenceText
} from 'common/utilities/utils';

const CommunicationPreferencesCard = ({ handleSubscriptionStatus, brazeSubscriptionStatus, loading, tenantReducer, brazeCookiesAccperted, handleOneTrustBanner }) => {
  const { COMMUNICATION_PREFERENCES_TEXT, UNSUBSCRIBE, SUBSCRIBE, MARKETING_EMAIL, MARKETING_SMS } = COMMUNICATION_PREFERENCES_CONSTANTS;
  return (
    <div className='preferences-card'>
      <div className='preferences-card-left-side preferences-card-left-side-au'>
        {translateWithI18Next(COMMUNICATION_PREFERENCES_TEXT)}
      </div>
      {<div className='preferences-card-right-side'>
        <div className='preferences-container'>
          <div className={`preferences-item ${!brazeCookiesAccperted ?'no-cookies-list':''}`}>
              <div className='preferences-item-list preferences-item-list-au'>
                <div className='preferences-text'>
                  <label htmlFor={translateWithI18Next(TRANSLATE_MAPPING_KEY.EMAIL_MARKETING)}>{translateWithI18Next(TRANSLATE_MAPPING_KEY.EMAIL_MARKETING)}</label>
                </div>
                <div>
                  <AnchorWithLink
                    data-testid='handleSubscriptionStatus-testid'
                    onClickHandler={() => handleSubscriptionStatus(brazeSubscriptionStatus, MARKETING_EMAIL)}
                    className = {`${!brazeCookiesAccperted ?'no-cookies-list':''}`}
                  >
                    {!loading &&
                      (brazeSubscriptionStatus?.email?.subscribed ? translateWithI18Next(UNSUBSCRIBE) : translateWithI18Next(SUBSCRIBE))}
                  </AnchorWithLink>
                </div>
              </div>
              {tenantReducer?.brazeSMSMarketingOption && <div className='preferences-item-list preferences-item-list-au'>
              {marketingPreferenceText()}
                <div>
                  <AnchorWithLink
                    data-testid='handleSubscriptionStatus-smstestid'
                    onClickHandler={() => handleSubscriptionStatus(brazeSubscriptionStatus, MARKETING_SMS)}
                    className = {`${!brazeCookiesAccperted ?'no-cookies-list':''}`}
                  >
                    {!loading &&
                      (brazeSubscriptionStatus?.sms?.subscribed ? translateWithI18Next(UNSUBSCRIBE) : translateWithI18Next(SUBSCRIBE))}
                  </AnchorWithLink>
                </div>
              </div>}
          </div>
          {!brazeCookiesAccperted && <p className='cookies-text'>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.PLEASE_MODIFY)} <span className='cookieslink-text' onClick={handleOneTrustBanner}>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.COOKIES_SETTINGS)}</span> {translateWithI18Next(TRANSLATE_MAPPING_KEY?.PREFERENCE_TEXT)}</p>}
        </div>
      </div>}
    </div>
    // )
  );
};

CommunicationPreferencesCard.propTypes = {
  handleSubscriptionStatus: PropTypes.func.isRequired,
};

CommunicationPreferencesCard.defaultProps = {};

export default CommunicationPreferencesCard;
